<template>
    <div class="alert-h5" v-show="visible" @click="onClose">
        <div class="alert-wx-content">
            <div class="ctx-box">请阅读并同意隐私条款</div>
            <div class="but-box">知道了</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            visible: false
        };
    },
    mounted() {},
    methods: {
        onOpen() {
            this.visible = true;
        },
        // 关闭页面方式
        onClose() {
            this.visible = false;
        }
    }
};
</script>

<style lang="less">
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.alert-h5 {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 10000;
    background-color: rgba(0, 0, 0, 0.3);
    color: rgba(26, 25, 25, 1);
    .center();
    .alert-wx-content {
        z-index: 1051;
        width: 300px;
        height: 150px;
        background-color: #fff;
        box-shadow: 0px 1px 5px 0px rgba(101, 101, 101, 0.08);
        border-radius: 6px;
        font-size: 16px;
        overflow: hidden;
        .ctx-box {
            .center();
            height: 105px;
            color: #363c54;
        }
        .but-box {
            .center();
            color: #00bebe;
            width: 100%;
            height: 45px;
            background-color: #fdfeff;
            border-top: 1px solid #f0f1f2;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/marketing_components/alert-h5.vue